import { getAuthorsApiCall } from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { AUTHORS } from '../types';

export const getAuthors = () => async dispatch => execute(dispatch, () => getAuthorsApiCall(), AUTHORS, false);
